import { render, staticRenderFns } from "./XsddDetail.vue?vue&type=template&id=5c40d64a&scoped=true&"
import script from "./XsddDetail.vue?vue&type=script&lang=js&"
export * from "./XsddDetail.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./XsddDetail.vue?vue&type=style&index=1&id=5c40d64a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c40d64a",
  null
  
)

export default component.exports